// extracted by mini-css-extract-plugin
export var body = "_redotech-redo-i18n-lib-locale-selector-body";
export var button = "_redotech-redo-i18n-lib-locale-selector-button";
export var closeButton = "_redotech-redo-i18n-lib-locale-selector-closeButton";
export var content = "_redotech-redo-i18n-lib-locale-selector-content";
export var empty = "_redotech-redo-i18n-lib-locale-selector-empty";
export var grid = "_redotech-redo-i18n-lib-locale-selector-grid";
export var header = "_redotech-redo-i18n-lib-locale-selector-header";
export var icon = "_redotech-redo-i18n-lib-locale-selector-icon";
export var option = "_redotech-redo-i18n-lib-locale-selector-option";
export var optionSelected = "_redotech-redo-i18n-lib-locale-selector-optionSelected";
export var overlay = "_redotech-redo-i18n-lib-locale-selector-overlay";
export var searchIcon = "_redotech-redo-i18n-lib-locale-selector-searchIcon";
export var searchInput = "_redotech-redo-i18n-lib-locale-selector-searchInput";
export var searchWrapper = "_redotech-redo-i18n-lib-locale-selector-searchWrapper";
export var title = "_redotech-redo-i18n-lib-locale-selector-title";
export var visuallyHidden = "_redotech-redo-i18n-lib-locale-selector-visuallyHidden";